import React from "react";
import {
  Box,
  Button,
  Grid,
  Link,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { useNavigate } from "react-router";


export const AllMenuCards = ( { cuisine } ) => {
  console.log("cuisineReal",cuisine)
  const data = [
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
      component: null,
    },
    //   {
    //       title: "See more 20 Cuisines ++",
    //       image1: "<EastIcon/>",
    //       dispProp:"flex",
    //       button: EastIcon,
    //       borderColor: "#D5E6E5",
    //       component: "button",

    //   },
  ];

  let navigate = useNavigate();

  return (
    <>
      <Box
        component="container"
        sx={{
          mt: "30px",
          justifyContent: { sm: "center" },
          alignItems: { sm: "center" },
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: {
                xl: "50px",
                lg: "40px",
                md: "40px",
                sm: "36px",
                xs: "30px",
              },
              fontWeight: "600",
              // paddingBottom: "16px",
            }}
          >
            Explore by cuisines
          </Typography>
        </Box>

        <Grid container spacing={2}>
          {cuisine?.map((v, i) => {
            return (
              <>
                <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
                  <Box
                    sx={{
                      backgroundColor: "#F0FAF9",
                      backgroundImage: "url(./images/thread.svg)",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "left top",
                      backgroundSize: { xl: "122px", lg: "auto" },
                      width: {
                        xl: "auto",
                        lg: "auto",
                        md: "auto",
                        sm: "auto",
                        xs: "100%",
                      },
                      // height: "122px",
                      height: { xl: "150px", lg: "122px" },
                      borderRadius: "8px",
                    }}
                  >
                    <Box
                      sx={{
                        display: `${v.dispProp}`,
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                        <Typography
                          sx={{
                            fontSize: {
                              xl: "24px",
                              lg: "24px",
                              md: "24px",
                              sm: "24px",
                              xs: "24px",
                            },
                            fontWeight: "600",
                            pb: "30px",
                            pl: "10px",
                            // pt: { xl: "200px", lg: "0px" },
                          }}
                        >
                          {v?.cuisine}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          // backgroundImage: "url(./images/bgCircle.svg)",
                          // backgroundRepeat: "no-repeat",
                          // backgroundPosition: "right top",
                          width: {
                            xl: "160px",
                            lg: "auto",
                            md: "140.21px",
                            sm: "100%",
                            xs: "100%",
                          },
                          // height: "140.21px",
                          height: {
                            xl: "140.21px",
                            lg: "140.21px",
                            md: "140.21px",
                            sm: "auto",
                            xs: "auto",
                          },
                        }}
                      >
                        <img src={"/images/allmenudish.svg"} alt="" height="auto" width="100%" />
                      </Box>
                      {/* <Box component= {`${v.component}`}>{`${v.button}`}</Box> */}
                    </Box>
                  </Box>
                </Grid>
              </>
            );
          })}

          { cuisine?.length > 15 ? (
            <>
            <Grid
            item
            sx={{
              border: "1px solid #D5E6E5",
              // backgroundColor: "#F0FAF9",
              width: {
                xl: "390px",
                lg: "290px",
                md: "290px",
                sm: "290px",
                xs: "100%",
              },
              height: {
                xl: "150px",
                lg: "122px",
                md: "122px",
                sm: "122px",
                xs: "200px",
              },
              borderRadius: "8px",
              display: "flex",
              flexDirection: "row",
              // alignItems: "center",
              justifyContent: "space-between",
              marginLeft: "24px",
              marginTop: "16px",
              //   width: "166px"
              // padding:"13px, 18px, 13px, 18px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: {
                    xl: "24px",
                    lg: "24px",
                    md: "24px",
                    sm: "24px",
                    xs: "24px",
                  },
                  fontWeight: "600",
                  //  paddingLeft: "18px"
                }}
              >
                See more 20 Cuisines ++
              </Typography>
            </Box>
            <Link component="button" onClick={() => navigate("/allcuisine")}>
              <Box
                sx={{
                  // paddingRight: "18px"
                  borderRadius: "50%",
                  backgroundColor: "#F0FAF9",

                  gap: "10px",
                  padding: {
                    xl: "12px",
                    lg: "12px",
                    md: "12px",
                    sm: "12px",
                    xs: "12px",
                  },
                  marginRight: "20px",
                  marginBottom: "20px",
                }}
              >
                <EastIcon
                  sx={{
                    width: {
                      xl: "24px",
                      lg: "24px",
                      md: "24px",
                      sm: "24px",
                      xs: "24px",
                    },
                    height: {
                      xl: "24px",
                      lg: "24px",
                      md: "24px",
                      sm: "24px",
                      xs: "24px",
                    },
                  }}
                />
              </Box>
            </Link>
          </Grid>
            </>
          ) :  ""}
       
        </Grid>
      </Box>
    </>
  );
};
